//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = "/prototype/accounting/general-ledger/budgets";

export default {
    data: function data() {
        return {
            headers: ["Account", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Total"],
            budget: { items: [] },
            accounts: [],
            addNew: false,
            addItem: { id: 0, jan: 0, feb: 0, mar: 0, apr: 0, may: 0, jun: 0, jul: 0, aug: 0, sep: 0, oct: 0, nov: 0, dec: 0 }
        };
    },
    mounted: function mounted() {
        var _this = this;

        var $el = this;

        Event.$on('edit-budget', function (budget) {
            _this.refresh(budget);
        });
    },


    methods: {
        refresh: function refresh(budget) {
            var _this2 = this;

            axios.post(BASE_URL + "/fetch", { id: budget }).then(function (response) {
                _this2.budget = response.data;
                _this2.budget.start = moment(response.data.start).format("MM/DD/YYYY");
                _this2.budget.end = moment(response.data.end).format("MM/DD/YYYY");
                _this2.addItem.budget_id = response.data.id;
                _this2.budget.items.map(function (item) {
                    item.account.label = item.account.number + ' - ' + item.account.name;
                });
                axios.post('/prototype/accounting/general-ledger/accounts/fetch').then(function (response) {
                    _this2.accounts = response.data;
                });
                _this2.$children[0].$data.showModal = true;
            });
        },
        addNewItem: function addNewItem() {
            this.addNew = true;
        },
        itemImport: function itemImport() {
            Event.$emit('import-budget', this.budget);
        },
        closeImport: function closeImport() {
            this.$children[0].$data.showSmallModal = false;
        },
        saveItem: function saveItem() {
            var _this3 = this;

            axios.post(BASE_URL + "/item/store", this.addItem).then(function (response) {
                var item = response.data;
                item.account.label = item.account.number + ' - ' + item.account.name;
                _this3.budget.items.push(item);
                _this3.addNew = false;
                _this3.addItem = { id: 0, jan: 0, feb: 0, mar: 0, apr: 0, may: 0, jun: 0, jul: 0, aug: 0, sep: 0, oct: 0, nov: 0, dec: 0 };
                _this3.addItem.budget_id = _this3.budget.id;
            });
        },
        save: function save() {
            var _this4 = this;

            axios.post(BASE_URL + "/update", this.budget).then(function (response) {
                Event.$emit('refresh-gl-budgets');
                _this4.$children[0].$data.showModal = false;
            });
        },
        itemTotal: function itemTotal(idx) {
            return parseFloat(this.budget.items[idx].jan + this.budget.items[idx].feb + this.budget.items[idx].mar + this.budget.items[idx].apr + this.budget.items[idx].may + this.budget.items[idx].jun + this.budget.items[idx].jul + this.budget.items[idx].aug + this.budget.items[idx].sep + this.budget.items[idx].oct + this.budget.items[idx].nov + this.budget.items[idx].dec);
        },
        addTotal: function addTotal() {
            return parseFloat(this.addItem.jan + this.addItem.feb + this.addItem.mar + this.addItem.apr + this.addItem.may + this.addItem.jun + this.addItem.jul + this.addItem.aug + this.addItem.sep + this.addItem.oct + this.addItem.nov + this.addItem.dec);
        },
        close: function close() {
            this.$children[0].$data.showModal = false;
        }
    },

    computed: {
        accountNames: function accountNames() {
            return this.accounts.map(function (account) {
                return { id: account.id, label: account.number + ' - ' + account.name };
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/budget/EditBudget.vue
// module id = FqFs
// module chunks = 0 1